import { Box, ColorOptions, Loader, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { ListNew } from '../../components/ListNew'
import { ModalAlertView } from '../../components/ModalAlertView'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'

type filterType = {
  [key: string]: string
}

const MerchantMapping = () => {
  const [isLoading, setLoading] = useState(false)
  const [isExpand, setIsExpand] = useState(false)
  const [isSyncAlertVisible, setSyncAlertVisible] = useState(false)

  const {
    getAll,
    getEntityMap,
    accessConfig,
    syncPam,
    config,
    exportByJobIdAsync,
    getAllEntities,
    accessConfigString,
  } = useStores((store) => ({
    getAll: store.merchantMapping.getAll,
    length: store.merchantMapping.merchants.length,
    getEntityMap: store.entityMaster.getEntityNameMap,
    syncPam: store.entityMaster.syncPam,
    config: store.user.accessConfig,
    accessConfig: store.user.getAccessConfig(['merchant_config', 'merchant_mapping']),
    accessConfigString: store.user.accessConfig,
    getAllEntities: store.entityMaster.getAllEntities,
    exportByJobIdAsync: store.exportByJobIdAsync,
  }))

  const searchFormRef = React.useRef(null)

  const [lazyGetAll, { state, data }] = useLazyApiData(getAll)
  const [lazygetEntityMap] = useLazyApiData(getEntityMap)
  const [getAllEntitiesApi, getAllEntitiesHandler] = useLazyApiData(getAllEntities)

  const entityIdList =
    getAllEntitiesHandler?.data?.content?.map((item) => ({
      ...item,
      value: item?.id + '-' + item?.name,
    })) ?? []

  const [syncPamApi, syncPamApiHandler] = useLazyApiData(syncPam)
  const [lazyExportByJobId, exportByJobIdAsyncHandler] = useLazyApiData(exportByJobIdAsync)

  const abortControllerRef: any = useRef({})

  const getAbortController = useCallback(() => {
    abortControllerRef.current.abortController = new AbortController()
    console.log('htag getAbortController ', abortControllerRef.current)
    return abortControllerRef.current
  }, [])

  useEffect(() => {
    getAllEntitiesApi({}, { page: 1, size: 10000 }, true)
  }, [getAllEntitiesApi])

  useEffect(
    () => () => {
      if (abortControllerRef && abortControllerRef.current) {
        abortControllerRef.current.abortRecursive = true
      }
    },
    [],
  )

  const exportFile = useCallback(() => {
    let searchData = searchFormRef?.current?.getValues()
    const processingEntity = searchData.processingEntity ? searchData.processingEntity.split('-')[0] : undefined
    searchData = { ...searchData, processingEntity }
    lazyExportByJobId(
      { jobType: 'PAM_MERCHANT_CONFIG_EXPORT', pamMerchantConfigFilter: searchData },
      getAbortController,
    )
  }, [getAbortController, lazyExportByJobId])

  const exportFile2 = useCallback(() => {
    let searchData = searchFormRef?.current?.getValues()
    const processingEntity = searchData.processingEntity ? searchData.processingEntity.split('-')[0] : undefined
    searchData = { ...searchData, processingEntity }
    lazyExportByJobId({ jobType: 'KEY_EXCHANGE_EXPORT', pamMerchantConfigFilter: searchData }, getAbortController)
  }, [getAbortController, lazyExportByJobId])

  useEffect(() => {
    lazygetEntityMap()
  }, [lazygetEntityMap])

  useEffect(() => {
    if (isAccessible(accessConfig, 'fetch')) {
      setLoading(true)
      lazyGetAll(searchFormRef?.current?.getValues() ?? {}, { page: 1, size: 10 })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessConfigString])

  useEffect(() => {
    if (state === 'fulfilled' || state === 'rejected') {
      setLoading(false)
    }
  }, [state])

  const keyExtractor = (item: any): string => {
    return item.id
  }

  const headTitles = [
    { ID: 'ID' },
    { merchantId: 'Merchant ID' },
    { processingEntity: 'Processing Entity' },
    { bankMerchantId: 'Bank Merchant Id' },
    { terminalId: 'Terminal Id' },
    { bankTerminalId: 'Bank Terminal Id' },
    { transactionType: 'Transaction Type' },
    { transactionMode: 'Transaction Mode' },
    { transactionSubType: 'Transaction SubType' },
    { status: 'status' },
    { createdAt: 'Created At' },
    { updatedAt: 'Updated At' },
    { createdBy: 'Created By' },
    { updatedBy: 'Updated By' },
  ]

  const navigation = useNavigation()
  const onPress = ({ item }: any) => {
    navigation.navigate('merchantDetails', { merchantData: item })
  }

  const handleSync = () => {
    syncPamApi()
    setSyncAlertVisible(false)
  }

  const fetchDataFromServer = useCallback((data, paginationInfo) => {
    lazyGetAll(data, paginationInfo)
  }, [])
  console.log('htag data', data?.content)
  const getMappingList = () => {
    if (isLoading) {
      return <Loader />
    }
    return (
      <Box>
        {/* <List
          keyExtractor={keyExtractor}
          headTitle={headTitles}
          numOfColumns={8}
          sizeConfig={[1, 2, 1.75, 1.75, 1.75, 1.75, 1.5, 1.75]}
          data={listData}
          onPress={onPress}
          onSearch={onSearch}
          filterData={filterData}
          listTitle={'Merchant Mapping List'}
          showSyncPam={true}
          onSync={() => setSyncAlertVisible(true)}
          hrefPath={'merchantDetails'}
          isColumnSearchEnabled={true}
          getFilteredData={merchantsList}
          exportFile={exportFile}
        />*/}
        <ListNew
          searchFormRef={searchFormRef}
          searchData={SEARCH_FILTERS(entityIdList) as any}
          data={data?.content}
          updatedPaginationInfo={{
            ...(data?.pageNo !== undefined && { page: data?.pageNo }),
            ...(data?.totalElements !== undefined && {
              total: data?.totalElements,
            }),
          }}
          sizeConfig={[1, 2, 1.75, 1.75, 1.75, 1.75, 1.5, 1.75, 1.75, 1.75, 1.75, 1.75, 1.75, 1.75, 1.75]}
          isSearchButtonLoading={state === 'pending'}
          apiHandler={{ state, data }}
          dbCollumnMapper={{ entityID: 'entityId' }}
          fetchDataFromServer={fetchDataFromServer}
          onRowItemClick={onPress}
          keyExtractor={keyExtractor}
          headTitle={headTitles}
          listTitle={'Merchant Mapping List'}
          showSyncPam={false}
          onSync={() => setSyncAlertVisible(true)}
          exportFile={exportFile}
          exportFile2={exportFile2}
          type={'SCROLLABLE'}
          isExportButtonLoading={exportByJobIdAsyncHandler.state === 'pending'}
          columnsWidth={getPosCustomColumnWidth}
        />

        <ModalAlertView
          show={isSyncAlertVisible}
          onDismiss={() => setSyncAlertVisible(false)}
          title="Sync PAM"
          message={'This will trigger PAM to flush all old merchant configs and sync all new one'}
          onPress={() => handleSync()}
          onCancel={() => setSyncAlertVisible(false)}
          buttonTitle="Sync"
          isLoading={syncPamApiHandler?.state === 'pending'}
        />
      </Box>
    )
  }

  const onUpdate = () => {
    setIsExpand(false)
    lazyGetAll(false)
  }

  return (
    <Box>
      <Text title={'Merchant Mapping'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
      <Spacer direction="vertical" size={24} />
      {isAccessible(accessConfig, 'fetch') && getMappingList()}
    </Box>
  )
}

const SEARCH_FILTERS = (entityIdList) => [
  [
    { key: 'merchantId', type: 'string', placeHolder: ' Merchant Id' },
    { key: 'bankEntityId', type: 'string', placeHolder: 'Bank Entity Id' },
    { key: 'bankTerminalId', type: 'string', placeHolder: 'Bank Terminal Id' },
  ],
  [
    {
      key: 'txnType',
      type: 'string',
      placeHolder: 'Transaction Type',
    },
    {
      key: 'instrumentType',
      type: 'string',
      placeHolder: 'Transaction SubType',
    },
    {
      key: 'mappingStatus',
      type: 'dropdown',
      placeHolder: 'Mapping Status',
      data: [
        { id: 1, value: 'ACTIVE' },
        { id: 2, value: 'INACTIVE' },
        { id: 3, value: 'DELETED' },
      ],
    },
  ],
  [
    {
      key: 'processingEntity',
      type: 'dropdownWithSearch',
      placeHolder: 'Processing Entity ID',
      data: entityIdList,
    },
    {
      key: 'spacer1',
      type: 'spacer',
    },
    {
      key: 'spacer2',
      type: 'spacer',
    },
  ],
]

export default MerchantMapping

export const getPosCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    ID: 200,
    merchantId: 200,
    processingEntity: 200,
    bankMerchantId: 200,
    terminalId: 200,
    bankTerminalId: 200,
    transactionType: 200,
    transactionMode: 200,
    transactionSubType: 200,
    status: 200,
    createdAt: 200,
    updatedAt: 200,
    createdBy: 200,
    updatedBy: 200,
    actionCode: 200,
  }
  return columnsKeyWidth[columnKey] ?? 200
}
